import { render, staticRenderFns } from "./NavCard.vue?vue&type=template&id=39bd75f3&scoped=true&"
import script from "./NavCard.vue?vue&type=script&lang=js&"
export * from "./NavCard.vue?vue&type=script&lang=js&"
import style0 from "./NavCard.vue?vue&type=style&index=0&id=39bd75f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bd75f3",
  null
  
)

export default component.exports